import Countries from './Countries';

export default Countries;


// WEBPACK FOOTER //
// ./src/components/Query/Countries/index.ts